import { render } from "./yt-vid-com.vue?vue&type=template&id=3a9bc3fb&scoped=true"
import script from "./yt-vid-com.vue?vue&type=script&lang=js"
export * from "./yt-vid-com.vue?vue&type=script&lang=js"

import "./yt-vid-com.vue?vue&type=style&index=0&id=3a9bc3fb&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9bc3fb"]])

export default __exports__